/* unplugin-vue-components disabled */import { render } from "./ai-profile-select.vue?vue&type=template&id=4f7368fe&scoped=true"
import script from "./ai-profile-select.vue?vue&type=script&lang=js"
export * from "./ai-profile-select.vue?vue&type=script&lang=js"

import "./ai-profile-select.vue?vue&type=style&index=0&id=4f7368fe&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7368fe"],['__file',"src/components/ai-chat-v2/ai-assistant/ai-input/ai-profile-select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f7368fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f7368fe', __exports__)) {
    api.reload('4f7368fe', __exports__)
  }
  
  module.hot.accept("./ai-profile-select.vue?vue&type=template&id=4f7368fe&scoped=true", () => {
    api.rerender('4f7368fe', render)
  })

}


export default __exports__